var SALE_COLLECTION_SCROLL_OFFSET = 150;
var saleCollectionProgrammaticScroll = false;
var saleCollectionScrollEndTimeout = null;

function updateSaleFiltersShadows($inner) {
  var el = $inner[0];
  var maxScroll = el.scrollWidth - el.clientWidth;
  var $filters = $inner.closest('.sale-filters');

  $filters.toggleClass('show-left-shadow', el.scrollLeft > 1);
  $filters.toggleClass('show-right-shadow', el.scrollLeft < maxScroll - 1);
}

function clearSaleCollectionProgrammaticScroll() {
  saleCollectionProgrammaticScroll = false;
}

function centerActiveSaleFilterPill($pill) {
  var $inner = $pill.closest('.sale-filters__inner');
  if (!$inner.length) return;

  var el = $inner[0];
  var innerRect = el.getBoundingClientRect();
  var pillRect = $pill[0].getBoundingClientRect();

  var pillCenter = pillRect.left - innerRect.left + el.scrollLeft + pillRect.width / 2;
  var target = pillCenter - el.clientWidth / 2;
  target = Math.max(0, Math.min(target, el.scrollWidth - el.clientWidth));

  el.scrollTo({ left: target, behavior: 'smooth' });
}

function setActiveSaleFilterPill($pills, id) {
  var $active = $pills.filter('[href="#' + id + '"]');
  if ($active.hasClass('is-active')) return;

  $pills.removeClass('is-active');
  $active.addClass('is-active');
  centerActiveSaleFilterPill($active);
}

function scrollToSaleCollectionBlock($target, $pill, $pills) {
  if (!$target.length) return;

  clearTimeout(saleCollectionScrollEndTimeout);
  saleCollectionProgrammaticScroll = true;
  setActiveSaleFilterPill($pills, $target.attr('id'));

  var top = $target.offset().top - SALE_COLLECTION_SCROLL_OFFSET;
  window.scrollTo({ top: top, behavior: 'smooth' });

  window.addEventListener('scrollend', clearSaleCollectionProgrammaticScroll, { once: true });
  saleCollectionScrollEndTimeout = setTimeout(clearSaleCollectionProgrammaticScroll, 1000);
}

function initSaleCollectionScrollSpy($pills, $blocks) {
  if (!('IntersectionObserver' in window)) return;

  var observer = null;

  function createObserver() {
    if (observer) observer.disconnect();

    var lineFromBottom = Math.max(window.innerHeight - SALE_COLLECTION_SCROLL_OFFSET - 1, 0);

    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || saleCollectionProgrammaticScroll) return;
          setActiveSaleFilterPill($pills, entry.target.id);
        });
      },
      {
        rootMargin: '-' + SALE_COLLECTION_SCROLL_OFFSET + 'px 0px -' + lineFromBottom + 'px 0px',
        threshold: 0
      }
    );

    $blocks.each(function () {
      observer.observe(this);
    });
  }

  createObserver();

  var resizeTimeout = null;
  $(window).on('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(createObserver, 200);
  });
}

$(document).ready(function () {
  $('.sale-filters__inner').each(function () {
    var $inner = $(this);

    updateSaleFiltersShadows($inner);
    $inner.on('scroll', function () {
      updateSaleFiltersShadows($inner);
    });
    $(window).on('resize', function () {
      updateSaleFiltersShadows($inner);
    });
  });

  var $pills = $('.sale-filters__pill');
  var $blocks = $('.sale-collection-block');

  if ($pills.length && $blocks.length) {
    $pills.on('click', function (e) {
      var href = $(this).attr('href') || '';
      if (href.charAt(0) !== '#') return;

      var $target = $(href);
      if (!$target.length) return;

      e.preventDefault();
      scrollToSaleCollectionBlock($target, $(this), $pills);
    });

    initSaleCollectionScrollSpy($pills, $blocks);
  }
});
